import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { H3 } from "../../../components/headline/Headline";
import { Event } from "../EventTypes";
import "./EventList.css";

function computeRemainingSpotsContent(event: Event): string {
    if (((event.remainingSpots * 100) / event.maxAttendees) > 20 && event.maxAttendees >= 10) {
        return 'Verfügbar';
    }
    return `Nur noch ${event.remainingSpots} verfügbar`;
}

export default function EventList() {

    const events: any = useLoaderData();
    const navigate = useNavigate();

    interface EventProps {
        event: Event;
    }
    function Event({ event }: EventProps) {
        const [active, setActive] = useState<boolean>(false);
        const remainingSpotsContent = computeRemainingSpotsContent(event);

        return <>
            <div className="event-wrapper" onClick={() => setActive(!active)}>
                <div className={`event-header`}>
                    <div className="event-column">{event.date}</div>
                    <div className="event-column align-right">{remainingSpotsContent}</div>
                </div>
                <div className="event-content">
                    <div className="event-row">
                        <div className="event-column">{event.title}</div>
                        <div className="event-column">{event.price} € / Person</div>
                    </div>
                    <div className="event-row">
                        <div className="event-description" dangerouslySetInnerHTML={{ __html: event.description }}></div>
                    </div>
                    <div className="event-row content-aligned-at-end">
                        <button className="event-button" disabled={event.remainingSpots === 0} onClick={() => navigate('/events/' + event.reference)}>{event.remainingSpots > 0 ? 'Buchen' : 'Ausgebucht'}</button>
                    </div>
                </div>
            </div >
        </>
    }

    return <>
        <H3 text='Wähle deinen Wunschtermin aus' />
        {events.length ? (
            <>

                {
                    events.map((event: Event) =>
                        <Event event={event} key={event.reference} />
                    )
                }
            </>
        ) : (
            <span>Zur Zeit bieten wir keine Events online an. Bitte wende dich für weitere Infos an <a href="mailto:moinmoin@cablesport.de">moinmoin@cablesport.de</a>.</span>
        )
        }
    </>
}